import { DEFAULT_TRANSLATION_STRINGS } from '@/i18n';

import { ERROR_STRINGS } from './resources/error-strings.const';

export const getErrorTitleKey = (
  domainCode: keyof typeof ERROR_STRINGS['errors']
): keyof typeof DEFAULT_TRANSLATION_STRINGS['en-GB']['errors'] | undefined => {
  return ERROR_STRINGS.errors[domainCode]?.titleTranslationKey || undefined;
};
